var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Modal, ModalBody, ModalFoot, ModalHead, Text, } from '@dixa/lib-shared-habla';
import { useState } from 'react';
import { twitterActions } from 'components/settings/actions/twitter';
import { deleteTwitterAccount } from 'components/settings/api/twitter';
import { NotificationType, useNotifications } from 'hooks/useNotifications';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import styles from '../../twitterSettings.module.scss';
export const RemoveTwitter = ({ account }) => {
    const dispatch = useAppDispatch();
    const notify = useNotifications();
    const [modalOpen, setModalOpen] = useState(false);
    const [asyncStatus, setAsyncStatus] = useState('succeeded');
    function handleRemoveTwitter() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                setAsyncStatus('loading');
                yield deleteTwitterAccount(account.account_id);
                setAsyncStatus('succeeded');
                dispatch(twitterActions.readAccounts());
                notify({
                    title: 'Twitter account removed',
                    time: 3000,
                }, NotificationType.Success);
            }
            catch (_a) {
                notify({
                    title: 'An error occurred when trying to remove the Twitter account',
                }, NotificationType.Error);
                setAsyncStatus('failed');
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ className: "btn btn-link btn-danger messenger-page__section__button", variant: "secondary", onClick: () => setModalOpen(true) }, { children: "Remove" })), _jsxs(Modal, Object.assign({ isOpen: modalOpen, className: styles.modal, onClose: () => setModalOpen(false) }, { children: [_jsx(ModalHead, { title: `Remove Twitter account? @${account.screen_name}`, onClose: () => setModalOpen(false) }), _jsx(ModalBody, { children: _jsx(Text.Paragraph, { children: `Are you sure you want to remove your Twitter account "${account.alias_name}" from Dixa? Please note that this action cannot be undone.` }) }), _jsx(ModalFoot, { confirmOnClick: handleRemoveTwitter, confirmName: "Delete", confirmProps: {
                            isLoading: asyncStatus === 'loading',
                            variant: 'danger',
                        }, cancelOnClick: () => setModalOpen(false) })] }))] }));
};
